var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("HardwareOnlyModal", { ref: "hardwareOnlyModal" }),
      _vm._v(" "),
      _vm.pricingModalIsOpen && !_vm.pricingModalComplete
        ? _c("MiniPricingForm", {
            on: {
              "hide-modal": function ($event) {
                return _vm.setPricingModal(false)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-4" },
        [
          _c(
            "div",
            { staticClass: "hero-container padding-bottom-2" },
            [
              _c("div", { staticClass: "webstore-hero" }, [
                _c("h1", [_vm._v(_vm._s(_vm.headerTitle))]),
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.selectedCategory === "All"
                  ? _c("div", {
                      staticClass: "webstore-banner",
                      style: _vm.webstoreHero,
                    })
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            !_vm.isAnonymousCustomer && !_vm.smallFleetOpportunity
              ? _c(
                  "div",
                  [
                    !_vm.contract.isContractOnFile
                      ? _c("Notice", {
                          attrs: { noticeType: "notice" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.webstoreContent.webstoreBody
                                            .missing_contract
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1923743753
                          ),
                        })
                      : _vm.hasContractExpired
                      ? _c("Notice", {
                          attrs: { noticeType: "notice" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.webstoreContent.webstoreBody
                                            .expired_contract
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1592169018
                          ),
                        })
                      : _vm.contract.isContractOnFile &&
                        _vm.checkoutType === "ExpressCheckout"
                      ? _c("Notice", {
                          attrs: { noticeType: "notice" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.webstoreContent.webstoreBody
                                              .express_checkout_co_term.text
                                          ) +
                                          " \n              "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            color: "#2a6496",
                                            "text-decoration": "underline",
                                          },
                                          attrs: {
                                            href: _vm.webstoreContent
                                              .webstoreBody
                                              .express_checkout_co_term.url,
                                            target: "”_blank”",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.webstoreContent.webstoreBody
                                                .express_checkout_co_term
                                                .url_text
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2893247341
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.productsBySelectedCategory, function (product) {
                return _c(
                  "div",
                  {
                    key: product.key,
                    staticClass: "col lg-4 md-6 xs-12 sm-9 featured-product",
                    attrs: { id: product.key },
                  },
                  [
                    _c("ProductListing", {
                      attrs: {
                        productFamily: product.family,
                        productKey: product.key,
                        productInfo:
                          _vm.productCatalog[product.family][product.key],
                      },
                      on: {
                        "anonymous-modal": _vm.openAnonymousModal,
                        "inquire-modal": _vm.openInquireModal,
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("v-button", {
            attrs: {
              position: "center",
              mobile: "8",
              tablet: "5",
              desktop: "2",
              styling: "primary",
              textAlign: "center",
              id: "checkout-button",
              disabled: _vm.quantityInCart === 0,
            },
            on: {
              onClickEvent: function ($event) {
                return _vm.trackCheckoutButtonClick()
              },
            },
            scopedSlots: _vm._u([
              {
                key: "content",
                fn: function () {
                  return [
                    _c("span", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.webstoreContent.proceedToCheckout) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }